
//674357219370735 fb app id real
//2049822855318927 test app id fb
import { defineComponent, ref, onMounted, onUpdated, reactive } from "vue";

//import { translate } from "element-plus";
import ApiService from "@/core/services/ApiService";
import { ElMessage } from "element-plus";
import axios from "axios";
import { ErrorMessage, Field, Form, useField, useForm } from "vee-validate";
import store from "@/store";
import i18n from "@/core/plugins/i18n";
import { func } from "@/core/plugins/globalfunc";
import * as Yup from "yup";

declare const window: any;
export default defineComponent({
  name: "customers-listing",
  mixins: [func],
  components: {
    //Datatable,
  },
  setup() {
    // Define a validation schema
    const schema = Yup.object({
      email: Yup.string().required("requiredEmail").email("emailFormat"),
    });

    // Create a form context with the validation schema
    const { errors, handleSubmit, validate } = useForm({
      validationSchema: schema,
    });

    // No need to define rules for fields
    //const username = ref('');
    const { value: email, errorMessage: emailError } =
      useField<string>("email");

    return {
      //login,
      validate,
      errors,
      email,
      emailError,
    };
  },
  data() {
    return {
      emailSent: false,
    };
  },
  mounted() {
    if (store.state.uid) {
      ElMessage.success(this.$t("alreadyLogin"));
    }
  },
  methods: {
    recoverPassword() {
      if (store.state.uid) {
        //Show already login when there's UID
        ElMessage.success(this.$t("alreadyLogin"));
      } else {
        this.validate().then((values) => {
          if (values.valid) {
            //Log in backend
            axios
              .post(
                "https://php.rankopen.com/plugin.php?id=api&mode=pub&tab=forgot&action=recoverPassword",
                JSON.stringify({
                  email: this.email,
                  lang: this.$i18n.locale,
                })
              )
              .then((response) => {
                if (response.data === "noEmail") {
                  ElMessage.error(this.$t("noEmail"));
                } else if (response.data === "sent") {
                  this.emailSent = true;
                } else if (response.data === "emailFail") {
                  ElMessage.error(this.$t("emailFail"));
                }
              })
              .catch((e) => {
                ElMessage.error(this.$t("recoverFail"));
              });
          }
        });
      }
    },
  },
});
